const TOKEN_KEY = 'adminToken';

// Token storage strategy:
// - Default (persist=false): sessionStorage — cleared when the tab closes, reduced
//   persistence vs localStorage. Still script-accessible, so XSS can steal it, but
//   the attack window is narrower.
// - Remember-me (persist=true): localStorage — survives tab/browser close. The user
//   opts into this explicitly; they accept the longer XSS exposure window.
// Neither option is as safe as an httpOnly cookie; that would require a backend change.

export const getToken = () => {
  const fromSession = sessionStorage.getItem(TOKEN_KEY);
  if (fromSession) return fromSession;

  // Honor an intentionally-persisted localStorage token (remember-me).
  // Do NOT auto-migrate it to sessionStorage — that would defeat the opt-in.
  const fromLocal = localStorage.getItem(TOKEN_KEY);
  if (fromLocal) return fromLocal;

  return null;
};

export const setToken = (token, { persist = false } = {}) => {
  if (!token) return;
  if (persist) {
    // Remember-me: write to localStorage so the token survives tab close.
    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.removeItem(TOKEN_KEY);
  } else {
    // Default: sessionStorage only.
    sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const clearToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
};
